/* ============================================================
   GORJESS AESTHETICS - Theme JS v5
   ============================================================ */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 1024;
  var isTouch = window.matchMedia('(hover: none)').matches;

  function isDesktop() {
    return window.innerWidth > MOBILE_BREAKPOINT;
  }

  /* ----------------------------------------------------------
     Sticky header shadow
  ---------------------------------------------------------- */
  var header = document.getElementById('SiteHeader');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 16);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----------------------------------------------------------
     Main nav dropdowns

     Previous bug: the panel sat 6px below the parent <li> using
     `top: calc(100% + 6px)`. That 6px gap sat OUTSIDE the
     parent's hover area, so moving the cursor from the link
     toward the panel dropped the :hover state and the menu
     closed before it could be reached. The CSS now uses a
     transparent bridge inside the parent's box, and this JS
     adds hover intent (a close delay), click and tap toggling,
     and keyboard support so the panel holds open.
  ---------------------------------------------------------- */
  var HOVER_OPEN_DELAY = 60;
  var HOVER_CLOSE_DELAY = 320;
  var hoverEnabled = header ? header.getAttribute('data-hover-open') !== 'false' : true;
  var navParents = [].slice.call(document.querySelectorAll('.main-nav .has-dropdown'));

  function setExpanded(item, state) {
    var trigger = item.querySelector('[data-nav-parent]');
    var toggle = item.querySelector('[data-nav-toggle]');
    if (trigger) trigger.setAttribute('aria-expanded', String(state));
    if (toggle) toggle.setAttribute('aria-expanded', String(state));
  }

  function closeAll(except) {
    navParents.forEach(function (item) {
      if (item === except) return;
      item.classList.remove('open');
      setExpanded(item, false);
    });
  }

  function openItem(item) {
    closeAll(item);
    item.classList.add('open');
    setExpanded(item, true);
  }

  function closeItem(item) {
    item.classList.remove('open');
    setExpanded(item, false);
  }

  navParents.forEach(function (item) {
    var openTimer = null;
    var closeTimer = null;
    var trigger = item.querySelector('[data-nav-parent]');
    var toggle = item.querySelector('[data-nav-toggle]');

    function clearTimers() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }

    if (hoverEnabled && !isTouch) {
      item.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimers();
        openTimer = setTimeout(function () { openItem(item); }, HOVER_OPEN_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        clearTimers();
        closeTimer = setTimeout(function () { closeItem(item); }, HOVER_CLOSE_DELAY);
      });
    }

    // Dedicated caret button: always click to toggle.
    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearTimers();
        if (item.classList.contains('open')) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    }

    if (trigger) {
      // On touch devices the first tap opens the panel rather than
      // following the link, so submenu items stay reachable.
      trigger.addEventListener('click', function (e) {
        if (!isDesktop()) return;
        if (!isTouch && hoverEnabled) return;
        if (!item.classList.contains('open')) {
          e.preventDefault();
          openItem(item);
        }
      });

      trigger.addEventListener('focus', function () {
        if (!isDesktop()) return;
        clearTimers();
        openItem(item);
      });
    }

    // Keep the panel open while any child has focus, close on tab-out.
    item.addEventListener('focusout', function (e) {
      if (!isDesktop()) return;
      if (item.contains(e.relatedTarget)) return;
      closeItem(item);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openParent = document.querySelector('.main-nav .has-dropdown.open [data-nav-parent]');
    closeAll(null);
    if (openParent) openParent.blur();
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.main-nav')) closeAll(null);
  });

  window.addEventListener('resize', function () {
    if (!isDesktop()) closeAll(null);
  }, { passive: true });

  /* ----------------------------------------------------------
     Mobile nav
  ---------------------------------------------------------- */
  var hamburger = document.querySelector('.hamburger');
  var mobileNav = document.getElementById('MobileNav');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      hamburger.classList.toggle('open', open);
      hamburger.setAttribute('aria-expanded', String(open));
      mobileNav.setAttribute('aria-hidden', String(!open));
      document.body.classList.toggle('nav-locked', open);
    });
  }

  document.querySelectorAll('[data-m-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var row = btn.closest('.m-has-children');
      if (!row) return;
      var open = row.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* ----------------------------------------------------------
     FAQ accordion
  ---------------------------------------------------------- */
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      var group = btn.closest('.faq-list') || document;

      group.querySelectorAll('.faq-q').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        if (b.nextElementSibling) b.nextElementSibling.classList.remove('open');
      });

      if (!isOpen && panel) {
        btn.setAttribute('aria-expanded', 'true');
        panel.classList.add('open');
      }
    });
  });

  /* ----------------------------------------------------------
     Collection filters and sort
     Submits on change, updates the URL, and swaps the grid in
     place so the page does not jump.
  ---------------------------------------------------------- */
  function renderFromUrl(url, pushState) {
    var wrapper = document.getElementById('CollectionResults');
    if (!wrapper) { window.location.href = url; return; }
    wrapper.classList.add('is-loading');

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newResults = parsed.getElementById('CollectionResults');
        var newFacets = parsed.getElementById('FacetPanel');
        var currentFacets = document.getElementById('FacetPanel');

        if (newResults) wrapper.innerHTML = newResults.innerHTML;
        if (newFacets && currentFacets) currentFacets.innerHTML = newFacets.innerHTML;

        if (pushState) history.pushState({ url: url }, '', url);
        bindFacets();
        wrapper.classList.remove('is-loading');
      })
      .catch(function () { window.location.href = url; });
  }

  function bindFacets() {
    var form = document.getElementById('FacetForm');
    if (!form) return;

    function submitFacets() {
      var params = new URLSearchParams(new FormData(form)).toString();
      renderFromUrl(window.location.pathname + '?' + params, true);
    }

    form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.addEventListener('change', submitFacets);
    });

    var sort = document.getElementById('SortBy');
    if (sort) sort.addEventListener('change', submitFacets);

    document.querySelectorAll('[data-facet-clear]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        renderFromUrl(link.getAttribute('href'), true);
      });
    });

    var drawerToggle = document.querySelector('[data-facet-drawer-toggle]');
    var drawer = document.getElementById('FacetPanel');
    if (drawerToggle && drawer) {
      drawerToggle.addEventListener('click', function () {
        var open = drawer.classList.toggle('open');
        drawerToggle.setAttribute('aria-expanded', String(open));
      });
    }

    document.querySelectorAll('[data-facet-group-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.facet-group');
        if (!group) return;
        var open = group.classList.toggle('open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  if (document.getElementById('FacetForm')) {
    bindFacets();
    window.addEventListener('popstate', function () {
      renderFromUrl(window.location.href, false);
    });
  }


  /* ----------------------------------------------------------
     Cart count badge in the header
  ---------------------------------------------------------- */
  function updateCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-icon').forEach(function (icon) {
          var badge = icon.querySelector('.cart-badge');
          if (cart.item_count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'cart-badge';
              icon.appendChild(badge);
            }
            badge.textContent = cart.item_count;
          } else if (badge) {
            badge.remove();
          }
          icon.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
        });
      })
      .catch(function () { /* badge is cosmetic, ignore */ });
  }


  /* ----------------------------------------------------------
     Smooth scroll for in-page anchors
  ---------------------------------------------------------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    var href = link.getAttribute('href');
    if (!href || href === '#') return;
    link.addEventListener('click', function (e) {
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ----------------------------------------------------------
     Scroll reveal
  ---------------------------------------------------------- */
  var revealTargets = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    revealTargets.forEach(function (el) { observer.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('in-view'); });
  }

})();

/* ==============================================================
   Product page (main-product section)
   Gallery thumbnails, variant switching, quantity and add to cart.
   ============================================================== */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function refreshCartBadge() {
    fetch(root() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-icon').forEach(function (icon) {
          var badge = icon.querySelector('.cart-badge');
          if (cart.item_count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'cart-badge';
              icon.appendChild(badge);
            }
            badge.textContent = cart.item_count;
          } else if (badge) {
            badge.remove();
          }
          icon.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
        });
      })
      .catch(function () { /* badge is cosmetic */ });
  }

  function initProduct(scope) {
    var section = scope || document;

    section.querySelectorAll('.pdp').forEach(function (pdp) {
      if (pdp.dataset.pdpBound === 'true') return;
      pdp.dataset.pdpBound = 'true';

      var mainImage = pdp.querySelector('[data-pdp-main-image]');
      var thumbs = pdp.querySelectorAll('[data-pdp-thumb]');
      var variantIdField = pdp.querySelector('[data-pdp-variant-id]');
      var priceEl = pdp.querySelector('[data-pdp-price]');
      var compareEl = pdp.querySelector('[data-pdp-compare]');
      var addBtn = pdp.querySelector('[data-pdp-add]');
      var addText = pdp.querySelector('[data-pdp-add-text]');
      var form = pdp.querySelector('.pdp-form');

      /* ---- gallery ---- */
      function showMedia(id, src) {
        if (!mainImage) return;
        if (src) mainImage.src = src;
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', id ? t.dataset.mediaId === String(id) : t.dataset.full === src);
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          showMedia(thumb.dataset.mediaId, thumb.dataset.full);
        });
      });

      /* ---- variants ---- */
      function applyVariant(data) {
        if (!data) return;

        if (variantIdField) variantIdField.value = data.id;

        if (priceEl && data.price) priceEl.textContent = data.price;

        if (compareEl) {
          if (data.compare) {
            compareEl.textContent = data.compare;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }

        if (addBtn) {
          var available = data.available === 'true' || data.available === true;
          addBtn.disabled = !available;
          if (addText) {
            addText.textContent = available
              ? (addBtn.dataset.addLabel || addText.dataset.original || addText.textContent)
              : (addBtn.dataset.soldOutLabel || 'Sold out');
          }
        }

        if (data.mediaId) {
          var match = pdp.querySelector('[data-pdp-thumb][data-media-id="' + data.mediaId + '"]');
          if (match) showMedia(data.mediaId, match.dataset.full);
        }

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', data.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* older browsers, skip */ }
      }

      var select = pdp.querySelector('[data-pdp-variant-select]');
      if (select) {
        if (addBtn && addText) addText.dataset.original = addText.textContent.trim();
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          applyVariant({
            id: opt.value,
            price: opt.dataset.price,
            compare: opt.dataset.compare,
            available: opt.dataset.available,
            mediaId: opt.dataset.mediaId
          });
        });
      }

      var optionBtns = pdp.querySelectorAll('[data-pdp-variant-option]');
      if (optionBtns.length) {
        if (addBtn && addText) addText.dataset.original = addText.textContent.trim();
        optionBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            optionBtns.forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            applyVariant({
              id: btn.dataset.variantId,
              price: btn.dataset.price,
              compare: btn.dataset.compare,
              available: btn.dataset.available,
              mediaId: btn.dataset.mediaId
            });
          });
        });
      }

      /* ---- quantity ---- */
      var qtyInput = pdp.querySelector('[data-pdp-qty-input]');
      pdp.querySelectorAll('[data-pdp-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.pdpQty, 10);
          qtyInput.value = next < 1 ? 1 : next;
        });
      });

      /* ---- add to cart ---- */
      if (form && addBtn) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return; /* let the browser post normally */
          e.preventDefault();
          if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;

          var original = addText ? addText.textContent : '';
          addBtn.classList.add('is-loading');

          fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(variantIdField ? variantIdField.value : 0),
                quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
              }]
            })
          })
            .then(function (r) {
              if (!r.ok) throw new Error('add failed');
              return r.json();
            })
            .then(function () {
              addBtn.classList.remove('is-loading');
              if (addText) addText.textContent = 'Added';
              refreshCartBadge();
              setTimeout(function () {
                if (addText) addText.textContent = original;
              }, 2200);
            })
            .catch(function () {
              addBtn.classList.remove('is-loading');
              if (addText) addText.textContent = 'Try again';
              setTimeout(function () {
                if (addText) addText.textContent = original;
              }, 2200);
            });
        });
      }
    });
  }

  initProduct(document);

  document.addEventListener('shopify:section:load', function (e) {
    initProduct(e.target);
  });
})();
